export default __webpack_public_path__ + "static/media/sp1.3fb946ea.jpeg";